export default __webpack_public_path__ + "static/media/thumbnail.fcd5e088.webp";